import * as shape from 'd3-shape';

import { GAUGE_CONFIG } from '@v2/pages/machines/common/components/MachineStatusGauge/constants';
import { PieDataItem, PieArcDatum, BuildGaugeArcsParams, GaugeArc } from '@v2/pages/machines/common/components/MachineStatusGauge/types';

const { startAngle, endAngle, padAngle } = GAUGE_CONFIG;

export const buildGaugeArcs = ({ activeSegments, totalMachines, emptyArcColor, outerRadius, innerRadius }: BuildGaugeArcsParams): GaugeArc[] => {
  const dataForPie = totalMachines > 0 ? activeSegments.map((s) => ({ ...s, value: s.count })) : [{ color: emptyArcColor, value: 1 }];

  const pie = shape.pie().value((d: PieDataItem) => d.value).sort(null).startAngle(startAngle).endAngle(endAngle);

  if (totalMachines > 0 && activeSegments.length > 1) {
    pie.padAngle(padAngle);
  }

  const pieSlices: PieArcDatum[] = pie(dataForPie);

  const arcGenerator = shape.arc().outerRadius(outerRadius).innerRadius(innerRadius).cornerRadius(0);

  return pieSlices.map((slice: PieArcDatum, index: number) => ({
    path: arcGenerator(slice) as string,
    color: dataForPie[index].color,
  }));
};
